import { findRel } from '../../../shared/utils/stringUtilities';
import './button.scss';
interface ButtonInterface {
    id?: string;
    type?: 'button' | 'input' | 'link';
    classname: string;
    text: string | undefined;
    onClickAction?: () => any;
    isDisabled: boolean | undefined;
    icon?: string;
    href?: string;
    gtmMark?: string;
    strictCss?: boolean;
    target?: string;
    download?: boolean;
    loader?: boolean;
}

const Button = (props: ButtonInterface) => {
    const {
        id,
        type,
        classname,
        text,
        onClickAction,
        isDisabled,
        href,
        icon,
        gtmMark,
        strictCss,
        target,
        loader,
    } = props;

    const isHttp = (url?: string) => {
        return url?.startsWith('http');
    };

    const typeButton = (tipo) => {
        switch (tipo) {
            case 'button':
                return (
                    <button
                        id={id}
                        className={`${strictCss || 'a-button '
                            } ${classname} ${gtmMark} ${loader || isDisabled ? '--disabled' : ''
                            }`}
                        disabled={loader ? true : isDisabled}
                        onClick={onClickAction}
                    >
                        {loader ? (
                            <div
                                data-testid="loader"
                                className={'a-button__loader'}
                            ></div>
                        ) : (
                            text || 'Aceptar'
                        )}
                    </button>
                );
            case 'link':
                return props.download ? (
                    <span
                        id={id}
                        className={`${strictCss ? '' : 'a-button '
                            } ${classname} ${gtmMark}`}
                        onClick={onClickAction}
                    >
                        {icon && <span className={`${icon}`} />}
                        {text}
                    </span>
                ) : (
                    <a
                        id={id}
                        href={href}
                        target={isHttp(href) ? '_blank' : target || '_self'}
                        rel={findRel(href)}
                        className={`${strictCss ? '' : 'a-button '
                            } ${classname} ${gtmMark}`}
                    >
                        {icon && <span className={`${icon}`} />}
                        {text}
                    </a>
                );
            default:
                return (
                    <input
                        className={`${strictCss || 'a-button '
                            } ${classname} ${gtmMark}`}
                        type="submit"
                        value={text}
                        disabled={isDisabled}
                    />
                );
        }
    };

    return <>{text ? typeButton(type) : <></>}</>;
};

export default Button;
